import { ReactNode } from "react"
import AuthenticatedSidebar from "@/modules/layout/ui/navbar/AuthenticatedSidebar"
import AuthenticatedNavbar from "@/modules/layout/ui/navbar/AuthenticatedNavbar"
import { OrganizationLoader } from "@/modules/layout/ui/components/OrganizationLoader"
import { CvUploadProvider } from "@/modules/recruitment/context/CvUploadContext"
import { DocPushProvider } from "@/modules/sage300/context/DocPushContext"
import { BulkRejectionProvider } from "@/modules/recruitment/context/BulkRejectionContext"
import { BulkVideoProvider } from "@/modules/recruitment/context/BulkVideoContext"
import { BulkAiCallProvider } from "@/modules/recruitment/context/BulkAiCallContext"

interface EmployeeLayoutProps {
  children: ReactNode
}

// AuthenticatedNavbar consumes these contexts unconditionally, so employee
// routes must supply them even though the underlying features are admin-only.
export default function EmployeeLayout({ children }: EmployeeLayoutProps) {
  return (
    <OrganizationLoader>
      <CvUploadProvider>
        <DocPushProvider>
          <BulkRejectionProvider>
            <BulkVideoProvider>
              <BulkAiCallProvider>
                <div className="flex h-screen bg-layout-bg">
                  <AuthenticatedSidebar />
                  <div className="flex-1 flex flex-col overflow-hidden">
                    <AuthenticatedNavbar />
                    <main className="flex-1 overflow-x-hidden overflow-y-auto bg-layout-bg">
                      {children}
                    </main>
                  </div>
                </div>
              </BulkAiCallProvider>
            </BulkVideoProvider>
          </BulkRejectionProvider>
        </DocPushProvider>
      </CvUploadProvider>
    </OrganizationLoader>
  )
}
